// Module
var code = "<svg width=\"11\" height=\"11\" viewBox=\"0 0 11 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M9.99878 1.00049L1 10\" stroke=\"#333333\" stroke-width=\"0.793\"/> <path d=\"M9.99878 9.99954L1 1\" stroke=\"#333333\" stroke-width=\"0.793\"/> </svg> ";
// Exports
module.exports = code;